module.exports = __webpack_public_path__ + "img/PL08909.b04cf5ae.svg";